import React, { useRef, useEffect } from 'react';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Tooltip,
  Legend,
  Filler,
} from 'chart.js';
import { Line } from 'react-chartjs-2';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Tooltip,
  Legend,
  Filler
);
ChartJS.register({
  id: 'startEndLabels',
  afterDatasetsDraw: (chart, args, opts) => {
    const { ctx } = chart;
    const meta = chart.getDatasetMeta(0);
    const dataset = chart.data.datasets[0].data;
    if (!meta.data.length) return;
    const offset = opts.offset || 4;
    const format = opts.format || ((v) => v);
    ctx.save();
    ctx.fillStyle = opts.color || '#fff';
    ctx.font = '10px sans-serif';
    ctx.textBaseline = 'bottom';
    const first = meta.data[0];
    const last = meta.data[meta.data.length - 1];
    ctx.textAlign = 'left';
    ctx.fillText(format(dataset[0]), first.x + offset, first.y - 4);
    ctx.textAlign = 'right';
    ctx.fillText(format(dataset[dataset.length - 1]), last.x - offset, last.y - 4);
    ctx.restore();
  },
});

function hexToRgb(hex) {
  const n = hex.replace('#', '');
  const bigint = parseInt(n, 16);
  const r = (bigint >> 16) & 255;
  const g = (bigint >> 8) & 255;
  const b = bigint & 255;
  return `${r}, ${g}, ${b}`;
}

function MiniLineChart({
  labels = [],
  data = [],
  label = '',
  color = '#ffff00',
  format = (v) => v,
}) {
  const chartRef = useRef(null);
  const rgb = hexToRgb(color);

  useEffect(() => {
    if (chartRef.current) {
      chartRef.current.update();
    }
  }, [labels, data]);
  const chartData = {
    labels,
    datasets: [
      {
        label,
        data,
        borderColor: color,
        backgroundColor: (ctx) => {
          const { chart } = ctx;
          const { ctx: c, chartArea } = chart;
          if (!chartArea) return `rgba(${rgb},0.2)`;
          const gradient = c.createLinearGradient(0, chartArea.top, 0, chartArea.bottom);
          gradient.addColorStop(0, `rgba(${rgb},0.4)`);
          gradient.addColorStop(1, `rgba(${rgb},0)`);
          return gradient;
        },
        fill: true,
        tension: 0.4,
        cubicInterpolationMode: 'monotone',
        clip: 4,
        pointRadius: 0,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      x: { display: false },
      y: { display: false },
    },
    plugins: {
      legend: { display: false },
      startEndLabels: { color, offset: 4, format },
    },
  };

  return (
    <div className="w-full h-full overflow-hidden">
      <Line ref={chartRef} data={chartData} options={options} />
    </div>
  );
}

export default MiniLineChart;
